import { render, staticRenderFns } from "./CertiRecord.vue?vue&type=template&id=54542346"
import script from "./CertiRecord.vue?vue&type=script&lang=js"
export * from "./CertiRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports